<template>
    <div class="min-h-screen bg-gray-50">
        <!-- Cabeçalho -->
        <header class="bg-white border-b border-gray-200">
            <div class="max-w-3xl mx-auto px-5 py-8 text-center">
                <img src="../assets/images/logo-light.png" alt="Resort Eco Business"
                    class="h-12 object-contain mx-auto mb-5" />
                <h1 class="text-2xl md:text-3xl font-bold text-gray-900">Política de Privacidade</h1>
                <p class="text-sm text-gray-500 mt-2">
                    Aplicativo <strong>Resort Eco Business</strong> (Android e iOS)
                </p>
                <p class="text-xs text-gray-400 mt-1">
                    Última atualização: {{ ultimaAtualizacao }} &nbsp;•&nbsp; Vigência a partir desta data
                </p>
            </div>
        </header>

        <!-- Conteúdo -->
        <main class="max-w-3xl mx-auto px-5 py-10">
            <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-10">

                <p class="text-gray-600 leading-relaxed mb-8">
                    Esta Política de Privacidade descreve como o <strong>Resort Eco Business</strong> coleta, usa,
                    armazena, compartilha e protege os dados pessoais dos usuários do aplicativo
                    <strong>Resort Eco Business</strong> (identificador
                    <code class="text-xs bg-gray-100 px-1.5 py-0.5 rounded">com.resortecobusiness.appcliente</code>),
                    em conformidade com a Lei nº 13.709/2018 (Lei Geral de Proteção de Dados – LGPD) e com as
                    políticas de dados do usuário do Google Play.
                </p>

                <!-- 1 -->
                <section class="mb-9">
                    <h2 class="text-lg font-bold text-gray-900 mb-3">1. Quem é o controlador dos seus dados</h2>
                    <p class="text-gray-600 leading-relaxed mb-3">
                        O controlador dos dados pessoais tratados no aplicativo é o
                        <strong>Resort Eco Business</strong>, responsável pela operação do empreendimento e do
                        aplicativo do cliente.
                    </p>
                    <ul class="text-gray-600 leading-relaxed space-y-1 text-sm">
                        <li><strong>CNPJ:</strong> {{ cnpj }}</li>
                        <li><strong>Endereço:</strong> {{ endereco }}</li>
                        <li><strong>E-mail de contato / encarregado (DPO):</strong>
                            <a :href="'mailto:' + emailContato" class="underline"
                                style="color:#527236">{{ emailContato }}</a>
                        </li>
                    </ul>
                    <p class="text-gray-500 leading-relaxed mt-3 text-sm">
                        O e-mail acima é o canal oficial para qualquer assunto relacionado a privacidade, proteção de
                        dados e exercício dos seus direitos.
                    </p>
                </section>

                <!-- 2 -->
                <section class="mb-9">
                    <h2 class="text-lg font-bold text-gray-900 mb-3">2. Dados que coletamos</h2>
                    <p class="text-gray-600 leading-relaxed mb-4">
                        Coletamos apenas os dados necessários para o funcionamento do aplicativo. Todos os dados abaixo
                        são fornecidos por você ou gerados pelo uso do app.
                    </p>

                    <div class="overflow-x-auto -mx-6 md:mx-0 px-6 md:px-0">
                        <table class="w-full text-sm border-collapse min-w-[560px]">
                            <thead>
                                <tr class="bg-gray-50 text-gray-700">
                                    <th class="text-left font-semibold p-3 border border-gray-200">Categoria</th>
                                    <th class="text-left font-semibold p-3 border border-gray-200">Dados</th>
                                    <th class="text-left font-semibold p-3 border border-gray-200">Finalidade</th>
                                </tr>
                            </thead>
                            <tbody class="text-gray-600 align-top">
                                <tr v-for="(item, i) in dados" :key="i">
                                    <td class="p-3 border border-gray-200 font-medium text-gray-800">
                                        {{ item.categoria }}</td>
                                    <td class="p-3 border border-gray-200">{{ item.dados }}</td>
                                    <td class="p-3 border border-gray-200">{{ item.finalidade }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="mt-5 p-4 rounded-xl bg-green-50 border border-green-100">
                        <p class="text-sm text-gray-700 leading-relaxed">
                            <strong>O que NÃO coletamos:</strong> não coletamos sua localização (precisa ou aproximada),
                            não acessamos sua lista de contatos, agenda, SMS, chamadas, arquivos pessoais, histórico de
                            navegação nem dados de saúde. O aplicativo <strong>não exibe anúncios</strong> e
                            <strong>não utiliza seus dados para publicidade</strong> ou rastreamento entre aplicativos.
                        </p>
                    </div>
                </section>

                <!-- 3 -->
                <section class="mb-9">
                    <h2 class="text-lg font-bold text-gray-900 mb-3">
                        3. Dados sensíveis: foto do rosto (biometria facial)
                    </h2>
                    <p class="text-gray-600 leading-relaxed mb-3">
                        Para permitir o acesso às dependências do resort por reconhecimento facial nas catracas, o
                        aplicativo solicita uma <strong>selfie</strong> no cadastro e permite atualizá-la no perfil.
                        A imagem facial é considerada <strong>dado pessoal sensível</strong> pela LGPD (art. 5º, II) e é
                        tratada mediante o seu <strong>consentimento específico e destacado</strong>, dado no momento em
                        que você escolhe tirar a foto.
                    </p>
                    <ul class="list-disc pl-5 text-gray-600 leading-relaxed space-y-1 text-sm">
                        <li>A foto é usada exclusivamente para identificar você no controle de acesso do resort.</li>
                        <li>A foto não é vendida, cedida ou usada para qualquer outra finalidade.</li>
                        <li>Você pode revogar o consentimento e solicitar a exclusão da imagem a qualquer momento pelos
                            canais da seção 9, ciente de que isso desativa o acesso facial às catracas.</li>
                    </ul>
                </section>

                <!-- 4 -->
                <section class="mb-9">
                    <h2 class="text-lg font-bold text-gray-900 mb-3">4. Permissões do dispositivo</h2>
                    <ul class="space-y-3 text-sm text-gray-600">
                        <li class="p-3 rounded-lg bg-gray-50 border border-gray-100">
                            <strong class="text-gray-800">Câmera</strong> — usada apenas quando você tira a selfie de
                            cadastro/perfil e quando escaneia um QR Code para transferir créditos. As imagens do leitor
                            de QR Code são processadas no próprio aparelho e não são armazenadas nem enviadas.
                        </li>
                        <li class="p-3 rounded-lg bg-gray-50 border border-gray-100">
                            <strong class="text-gray-800">Notificações</strong> — usada para enviar avisos sobre
                            comandas, créditos, promoções e comunicados do resort. Você pode desativar as notificações
                            nas configurações do seu aparelho a qualquer momento.
                        </li>
                        <li class="p-3 rounded-lg bg-gray-50 border border-gray-100">
                            <strong class="text-gray-800">Internet</strong> — necessária para a comunicação com nossos
                            servidores.
                        </li>
                    </ul>
                    <p class="text-gray-600 leading-relaxed mt-3 text-sm">
                        Todas as permissões são solicitadas no momento do uso e podem ser recusadas — nesse caso, apenas
                        a funcionalidade correspondente fica indisponível.
                    </p>
                </section>

                <!-- 5 -->
                <section class="mb-9">
                    <h2 class="text-lg font-bold text-gray-900 mb-3">5. Bases legais do tratamento</h2>
                    <ul class="list-disc pl-5 text-gray-600 leading-relaxed space-y-1 text-sm">
                        <li><strong>Execução de contrato</strong> (art. 7º, V da LGPD): cadastro, autenticação,
                            créditos/cashback, comandas, cardápio e suporte.</li>
                        <li><strong>Cumprimento de obrigação legal</strong> (art. 7º, II): guarda de registros fiscais e
                            de transações financeiras.</li>
                        <li><strong>Consentimento</strong> (arts. 7º, I e 11, I): foto facial e envio de notificações
                            promocionais.</li>
                        <li><strong>Legítimo interesse</strong> (art. 7º, IX): segurança, prevenção a fraudes e melhoria
                            do aplicativo.</li>
                    </ul>
                </section>

                <!-- 6 -->
                <section class="mb-9">
                    <h2 class="text-lg font-bold text-gray-900 mb-3">6. Compartilhamento de dados</h2>
                    <p class="text-gray-600 leading-relaxed mb-3">
                        <strong>Não vendemos nem compartilhamos seus dados pessoais com terceiros para uso próprio
                        deles.</strong> Seus dados são transmitidos apenas a prestadores de serviço (operadores, nos
                        termos do art. 5º, VII da LGPD) que os tratam exclusivamente em nosso nome, sob contrato e
                        conforme nossas instruções:
                    </p>
                    <ul class="list-disc pl-5 text-gray-600 leading-relaxed space-y-1 text-sm">
                        <li><strong>Google Firebase Cloud Messaging</strong> (Google LLC) — entrega das notificações
                            push. Recebe apenas o token do dispositivo e o conteúdo da notificação.</li>
                        <li><strong>Instituição financeira / provedor de pagamentos Pix</strong> — processamento das
                            compras de crédito, com os dados exigidos pelo arranjo Pix.</li>
                        <li><strong>Provedores de infraestrutura e hospedagem</strong> — armazenamento e operação dos
                            servidores, como operadores de dados sob contrato.</li>
                        <li><strong>Autoridades públicas</strong> — quando houver obrigação legal, ordem judicial ou
                            requisição de autoridade competente.</li>
                    </ul>
                    <p class="text-gray-600 leading-relaxed mt-3 text-sm">
                        Nenhum desses prestadores está autorizado a usar seus dados para finalidades próprias, nem para
                        publicidade, perfilamento ou revenda.
                    </p>
                    <p class="text-gray-600 leading-relaxed mt-3 text-sm">
                        Alguns desses parceiros podem processar dados fora do Brasil. Nesses casos, a transferência
                        internacional observa o art. 33 da LGPD e cláusulas contratuais de proteção adequadas.
                    </p>
                </section>

                <!-- 7 -->
                <section class="mb-9">
                    <h2 class="text-lg font-bold text-gray-900 mb-3">7. Segurança e armazenamento</h2>
                    <ul class="list-disc pl-5 text-gray-600 leading-relaxed space-y-1 text-sm">
                        <li>Toda a comunicação entre o aplicativo e nossos servidores é criptografada com HTTPS/TLS.</li>
                        <li>Tokens de autenticação e o identificador do dispositivo ficam no armazenamento seguro do
                            sistema operacional (Keychain no iOS, EncryptedSharedPreferences no Android).</li>
                        <li>Sua senha é armazenada apenas em formato criptografado (hash), nunca em texto legível.</li>
                        <li>O acesso interno aos dados é restrito a colaboradores autorizados.</li>
                        <li>Os dados são armazenados em servidores localizados no Brasil.</li>
                    </ul>
                </section>

                <!-- 8 -->
                <section class="mb-9">
                    <h2 class="text-lg font-bold text-gray-900 mb-3">8. Por quanto tempo guardamos seus dados</h2>
                    <p class="text-gray-600 leading-relaxed text-sm">
                        Mantemos seus dados enquanto sua conta estiver ativa. Após o pedido de exclusão, os dados de
                        cadastro e a imagem facial são eliminados em até <strong>30 dias</strong>. Registros de
                        transações financeiras (compras e transferências de crédito) e registros de acesso à aplicação
                        são mantidos pelos prazos exigidos pela legislação fiscal e pelo art. 15 do Marco Civil da
                        Internet, de forma segregada, e depois eliminados ou anonimizados.
                    </p>
                </section>

                <!-- 9 -->
                <section class="mb-9">
                    <h2 class="text-lg font-bold text-gray-900 mb-3">9. Seus direitos e exclusão da conta</h2>
                    <p class="text-gray-600 leading-relaxed mb-3 text-sm">
                        Nos termos do art. 18 da LGPD, você pode solicitar: confirmação da existência de tratamento;
                        acesso aos dados; correção de dados incompletos ou desatualizados; anonimização, bloqueio ou
                        eliminação de dados desnecessários; portabilidade; informação sobre compartilhamento; e
                        revogação do consentimento.
                    </p>
                    <div class="p-4 rounded-xl border-2 border-dashed border-gray-200 bg-gray-50">
                        <p class="font-semibold text-gray-800 mb-2 text-sm">Como excluir sua conta e seus dados</p>
                        <p class="text-sm text-gray-600 leading-relaxed">
                            Envie um e-mail para
                            <a :href="'mailto:' + emailContato" class="underline font-medium"
                                style="color:#527236">{{ emailContato }}</a>
                            com o assunto <strong>“Exclusão de conta”</strong>, informando o CPF e o e-mail cadastrados
                            no aplicativo. Confirmada a sua identidade, a conta e os dados pessoais associados
                            (incluindo a foto facial) são excluídos em até 30 dias, ressalvados os registros que a lei
                            obriga a manter, conforme a seção 8. O pedido é gratuito.
                        </p>
                    </div>
                    <p class="text-gray-600 leading-relaxed mt-3 text-sm">
                        Responderemos às solicitações em até 15 dias. Você também pode alterar seus dados cadastrais a
                        qualquer momento na tela <strong>Perfil → Editar perfil</strong> do aplicativo.
                    </p>
                </section>

                <!-- 10 -->
                <section class="mb-9">
                    <h2 class="text-lg font-bold text-gray-900 mb-3">10. Crianças e adolescentes</h2>
                    <p class="text-gray-600 leading-relaxed text-sm">
                        O aplicativo é destinado a maiores de 18 anos. Não coletamos intencionalmente dados de crianças
                        ou adolescentes sem o consentimento específico de um dos pais ou responsável legal. Caso
                        identifiquemos um cadastro nessas condições, os dados serão excluídos. Se você é responsável e
                        acredita que um menor sob sua guarda se cadastrou, entre em contato pelo e-mail da seção 1.
                    </p>
                </section>

                <!-- 11 -->
                <section class="mb-9">
                    <h2 class="text-lg font-bold text-gray-900 mb-3">11. Alterações desta política</h2>
                    <p class="text-gray-600 leading-relaxed text-sm">
                        Podemos atualizar esta política para refletir mudanças no aplicativo ou na legislação. A versão
                        vigente está sempre disponível nesta página, com a data da última atualização no topo. Mudanças
                        relevantes serão comunicadas pelo aplicativo ou por e-mail e, quando exigido, solicitaremos novo
                        consentimento.
                    </p>
                </section>

                <!-- 12 -->
                <section>
                    <h2 class="text-lg font-bold text-gray-900 mb-3">12. Contato</h2>
                    <p class="text-gray-600 leading-relaxed text-sm">
                        Dúvidas, solicitações ou reclamações sobre privacidade e proteção de dados:
                        <a :href="'mailto:' + emailContato" class="underline font-medium"
                            style="color:#527236">{{ emailContato }}</a>.
                        Você também pode apresentar reclamação à Autoridade Nacional de Proteção de Dados (ANPD).
                    </p>
                </section>
            </div>

            <p class="mt-8 text-xs text-gray-400 text-center">
                © {{ anoAtual }} Resort Eco Business. Todos os direitos reservados.
            </p>
        </main>
    </div>
</template>

<script>
export default {
    name: 'PoliticaDePrivacidade',
    data() {
        return {
            anoAtual: new Date().getFullYear(),
            ultimaAtualizacao: '4 de setembro de 2026',
            emailContato: 'contato@resortecobusiness.com.br',
            cnpj: '06.277.666/0001-78',
            endereco: 'QQ5H+CP - Roxo Roiz, Ponta Grossa - PR, Brasil',
            dados: [
                {
                    categoria: 'Identificação',
                    dados: 'Nome completo, CPF, data de nascimento, sexo',
                    finalidade: 'Criar e manter sua conta, identificar você no resort e nas catracas de acesso',
                },
                {
                    categoria: 'Contato',
                    dados: 'E-mail e telefone',
                    finalidade: 'Autenticação, recuperação de senha, avisos sobre a conta e suporte',
                },
                {
                    categoria: 'Endereço',
                    dados: 'CEP, logradouro, número, complemento, bairro, cidade e estado',
                    finalidade: 'Cadastro do cliente e emissão de documentos fiscais',
                },
                {
                    categoria: 'Credenciais',
                    dados: 'Senha (armazenada apenas em formato criptografado) e tokens de sessão',
                    finalidade: 'Autenticar seu acesso e manter a sessão segura',
                },
                {
                    categoria: 'Imagem facial (dado sensível)',
                    dados: 'Selfie tirada por você no cadastro ou no perfil',
                    finalidade: 'Reconhecimento facial para liberação de acesso nas catracas do resort',
                },
                {
                    categoria: 'Financeiros',
                    dados: 'Saldo de cashback, compras de crédito via Pix, histórico e transferências de crédito entre usuários',
                    finalidade: 'Processar pagamentos, manter seu saldo e exibir o histórico de transações',
                },
                {
                    categoria: 'Consumo',
                    dados: 'Comanda ativa e pedidos realizados nas lojas do resort',
                    finalidade: 'Exibir sua comanda, o cardápio e permitir o consumo com crédito',
                },
                {
                    categoria: 'Dispositivo',
                    dados: 'Identificador anônimo do aparelho, plataforma, marca, modelo, versão do sistema, versão do app e token de notificações (Firebase)',
                    finalidade: 'Enviar notificações, garantir a segurança da sessão, verificar atualizações e dar suporte técnico',
                },
                {
                    categoria: 'Preferências',
                    dados: 'Tema do aplicativo (claro/escuro), guardado apenas no seu aparelho',
                    finalidade: 'Manter suas preferências de uso',
                },
            ],
        };
    },
};
</script>
